import appointmentService from './appointmentService'

export default appointmentService



// WEBPACK FOOTER //
// ../src/services/appointmentService/index.js